import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TelegramChannelService {

    RequestOptions: any = {};

    constructor(
        private http: HttpRequestService,
    ) { }

    gets(parameters) {
        return this.http.get('telegramChannels', parameters)
            .map(res => {
                return res.json();
            })
    }

    stop(model: any) {
        return this.http.put(`telegramChannels/stop`,
            model).map(res => {
                return res.json();
            });
    }

    delete(id: number) {
        return this.http.delete(`telegramChannels/delete?id=${id}`)
            .map(res => {
                return res.json();
            });
    }

    add(model: any) {
        return this.http.post('telegramChannels/add', model)
            .map(res => {
                return res.json();
            });
    }

    save(model: any) {
        return this.http.post('telegramChannel', model)
            .map(res => {
                return res.json();
            });
  }

    getTelegram() : Observable<any[]>{
        return this.http.get(`get-telegram-active/telegram`)
            .map(res => {
                return res.json()
            });
    }

    getTelegramAll() : Observable<any[]>{
        return this.http.get(`get-telegram-active/telegramAll`)
            .map(res => {
                return res.json()
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/telegram-channel.service.ts